const AR_CUSTOM = {
  accessToWifi: 'يجب توفر إمكانية الوصول إلى شبكة Wi-Fi في موقع الشحن',
  AFTER_10PM_BEFORE_11AM:
    'بعد الساعة العاشرة مساءً؛ قبل الساعة الحادية عشرة صباحاً',
  AFTER_11AM_BEFORE_10PM:
    'بعد الساعة الحادية عشرة صباحاً؛ قبل الساعة العاشرة مساءً',
  AFTER_1230AM_BEFORE_930AM: 'بعد الساعة 12:30 صباحًا؛ قبل الساعة 9:30 صباحًا',
  AFTER_12PM_BEFORE_8PM: 'بعد الساعة 12 ظهراً؛ قبل الساعة 8 مساءً',
  AFTER_2PM_BEFORE_6PM: 'بعد الساعة الثانية ظهراً؛ قبل الساعة السادسة مساءً',
  AFTER_6AM_BEFORE_3PM: 'بعد الساعة السادسة صباحاً؛ قبل الساعة الثالثة مساءً',
  AFTER_6PM_BEFORE_9AM: 'بعد الساعة السادسة مساءً؛ قبل الساعة التاسعة صباحاً',
  AFTER_8AM_BEFORE_MN: 'بعد الساعة الثامنة صباحاً؛ قبل منتصف الليل',
  AFTER_9PM_BEFORE_6AM: 'بعد الساعة التاسعة مساءً؛ قبل الساعة السادسة صباحاً',
  AFTER_9PM_BEFORE_9AM: 'بعد الساعة التاسعة مساءً؛ قبل الساعة التاسعة صباحاً',
  AFTER_MN_BEFORE_8AM: 'بعد منتصف الليل؛ قبل الساعة الثامنة صباحاً',
  'after.Incentives': 'بعد الحوافز',
  age: 'عمر',
  agreeOffPeakSchedule:
    'الموافقة على فرض رسوم وفقًا لجدول زمني خارج أوقات الذروة',
  all: 'الجميع',
  ALL_HOURS: 'على مدار الساعة (بشكل غير متوقع)',
  'assumption.downPayment': 'دفعة مبدئية',
  'assumption.downPaymentValue': '10% من سعر التجزئة المقترح + الضريبة',
  'assumption.electricityRate': 'سعر الكهرباء',
  'assumption.gasolinePrice': 'سعر البنزين',
  'assumption.salesTax': 'ضريبة المبيعات',
  'assumption.salesTaxPercent': 'نسبة ضريبة المبيعات',
  ATTACHED_GARAGE: 'مرآب ملحق',
  averageMonthlyCharge: 'متوسط التكلفة الشهرية',
  averageMonthlyCharge_tool:
    'حدد إجمالي فواتير الكهرباء (باستثناء فواتير الغاز) في فاتورة شهرية نموذجية، بغض النظر عن الموسم. نستخدم هذا المبلغ لتقدير خط أساس لاستهلاكك الحالي للطاقة.',
  basement: 'الطابق السفلي',
  basicFilters: 'المرشحات الأساسية',
  certifiedElectrician: 'كهربائي معتمد',
  charger: 'شاحن',
  chargeWithLevelTwoCharger:
    'اشحن باستخدام شاحن من المستوى الثاني المؤهل أو قم بقيادة مركبة كهربائية مؤهلة',
  charging: 'الشحن',
  'chargingMap.businessGovernment': 'تم تركيبه بواسطة شركة أو جهة حكومية',
  'chargingMap.DCChargers': 'الشحن السريع بالتيار المستمر أو الشواحن الفائقة',
  'chargingMap.disclaimer':
    'البيانات مقدمة من مركز بيانات الوقود البديل. قد لا تعكس الخريطة أحدث المعلومات حول توافر محطات الشحن.',
  'chargingMap.errorZipcode': 'خطأ: الرمز البريدي {workingZipcode} غير صالح',
  'chargingMap.highPowerStations': 'محطات الطاقة العالية',
  'chargingMap.otherSttations': 'أنواع أخرى من المحطات',
  'chargingMap.privateStations': 'محطات خاصة',
  'chargingMap.public': 'محطات عامة',
  'chargingMap.searchDealers': 'ابحث عن الموزعين المؤهلين',
  'chargingMap.showFullListOfStations': 'قائمة كاملة بالمحطات',
  'chargingMap.updateZipcode': 'تحديث الرمز البريدي',
  chargingStations: 'محطات الشحن',
  'chargingStations.mapLegend.high': 'محطات الطاقة العالية',
  'chargingStations.mapLegend.highSubtext':
    'الشحن السريع بالتيار المستمر أو الشواحن الفائقة',
  'chargingStations.mapLegend.other': 'أنواع أخرى من المحطات',
  'chargingStations.mapLegend.private': 'محطات خاصة',
  'chargingStations.mapLegend.public': 'المحطات العامة',
  'chargingStations.mapLegend.publicSubtext':
    'تم تركيبه بواسطة شركة أو جهة حكومية',
  'chargingWizard.carOvernight': 'أين ستوقف سيارتك طوال الليل؟',
  'chargingWizard.chargingAvailability': 'إمكانية الشحن',
  'chargingWizard.electricianInstall': 'هل يُسمح لفني كهرباء بتركيب محطة شحن؟',
  'chargingWizard.noChargingAvailability': 'لا تتوفر خدمة الشحن',
  'chargingWizard.onTheStreet': 'في الشارع',
  'chargingWizard.overnightParking':
    'هل يمكنك ركن السيارة طوال الليل في مكان مزود بمحطة شحن؟',
  'chargingWizard.parkingGarage': 'مرآب خاص أو موقف سيارات',
  'chargingWizard.powerOutlet':
    'هل يوجد منفذ كهربائي عادي بالقرب من مكان ركن سيارتك؟',
  'chargingWizard.publicParking': 'موقف سيارات عام',
  'chargingWizard.useThisValue': 'استخدم هذه القيمة',
  'chargingWizard.youWouldHave': 'سيكون لديك {resultText}',
  close: 'يغلق',
  compareVehicles: 'مقارنة المركبات',
  'compareVehicles.carMake': 'ماركة السيارة',
  'compareVehicles.carModel': 'طراز السيارة',
  'compareVehicles.disclaimer': 'ليست جميع الماركات/الموديلات متوفرة.',
  'compareVehicles.fuelType': 'نوع الوقود',
  'compareVehicles.pickTwo': 'اختر سيارتين على الأقل لبدء المقارنة',
  'compareVehicles.selectFuel': 'اختر نوع الوقود',
  'compareVehicles.selectMake': 'اختر ماركة',
  'compareVehicles.selectModel': 'اختر طرازًا',
  'compareVehicles.subTitle': 'عرض جميع المركبات >',
  contact: 'اتصال',
  ContactInformation: 'معلومات الاتصال',
  conventionalVehicleEfficiency:
    'كفاءة استهلاك الوقود في المركبات التقليدية (ميل لكل جالون)',
  conventionalVehicleEfficiencyTooltip:
    'لحساب الوفورات المحتملة، أدخل عدد الأميال لكل جالون (MPG) لسيارة البنزين التي تريد استبدالها بسيارة كهربائية بالكامل أو سيارة هجينة قابلة للشحن.',
  costOfPublicCharging: 'تكلفة الشحن العام',
  costOfPublicChargingTooltip:
    'نقوم بتقدير تكلفة محطات الشحن العامة المدفوعة، ولكن يمكنك تعديل هذا الفلتر إذا كنت تعرف تكلفة الشحن المحلية.',
  CountiesCovered: 'المقاطعات المشمولة',
  currency: 'دولار',
  currentPricingPlan: 'خطة التسعير الحالية',
  dealers: 'التجار',
  'dealers.allBrands': 'جميع العلامات التجارية',
  'dealers.allDealers': 'جميع الموزعين',
  'dealers.brands': 'العلامات التجارية',
  'dealers.contact': 'اتصال',
  'dealers.findDealers': 'ابحث عن الموزعين',
  'dealers.website': 'موقع إلكتروني',
  description: 'وصف',
  DETACHED_GARAGE: 'مرآب منفصل',
  detailedCalculations: 'تفاصيل',
  driveEVOrPHEV: 'قيادة سيارة كهربائية (كهربائية بالكامل أو هجينة قابلة للشحن)',
  DRIVEWAY: 'ليس في مرآب',
  DRParagraph1:
    'تعتمد خطة تسعير إدارة الطلب القياسية على كمية الكهرباء التي تستهلكها،\n\nوليس على وقت استهلاكها. كلما قل استهلاكك للكهرباء، قلّ ما تدفعه،\n\nفي أي وقت، ليلاً أو نهاراً.',
  DRParagraph2:
    'قد تكون هذه الخطة مناسبة للأسر ذات الاستهلاك المنخفض وللأولئك الذين\n\nيفضلون التوفير عن طريق الترشيد دون التفكير في وقت اليوم.',
  egbBringCharger: 'سأستخدم شاحن المستوى الثاني الخاص بي',
  egbNeedCharger: 'أحتاج إلى شاحن من المستوى الثاني',
  egbOurPrograms:
    'لدينا برامج تُسهّل عملية شحن السيارات الكهربائية في المنزل. إذا كنت بحاجة إلى شاحن من المستوى الثاني، فقد يكون برنامجنا "تسريع شحن السيارات الكهربائية في المنزل" مناسبًا لك.',
  electricians: 'كهربائيون',
  'electricians.commercial': 'تجاري',
  'electricians.fastEfficient':
    '{title} جداول التثبيت لدينا آمنة وسريعة لمساعدتك على البدء في العمل في أسرع وقت ممكن.',
  'electricians.industrial': 'صناعي',
  'electricians.map.caption':
    'هل أنت فني تركيب معتمد لمحطات شحن السيارات الكهربائية في منطقة سان دييغو؟ يرجى التواصل مع {email} للنظر في إمكانية إدراجك في قاعدة بياناتنا للفنيين الكهربائيين المعتمدين. الفنيون الكهربائيون المدرجون في هذا الموقع ليسوا معتمدين أو مدعومين أو موظفين لدى شركة SDG&E.',
  'electricians.map.header': 'مزايا شركائنا المفضلين',
  'electricians.map.personalizedExperience':
    'بإمكان متخصصي السيارات الكهربائية لدينا مساعدتك في إرشادك خلال العملية بأكملها.',
  'electricians.map.value': 'نقدم أسعار تركيب تنافسية.',
  'electricians.residential': 'سكني',
  'electricians.searchElectricians': 'ابحث عن كهربائيين مؤهلين',
  'electricians.subtitle':
    'أدخل الرمز البريدي الخاص بك للعثور على كهربائيين معتمدين في منطقتك. انقر على كل نتيجة لعرض الموقع ومعلومات الاتصال.',
  'electricians.title': 'كهربائيون معتمدون',
  'electricians.type': 'نوع كهربائي',
  'electricians.worldClass':
    'نتعاون مع كهربائيين ذوي خبرة تم التحقق من كفاءتهم لضمان تركيب آمن واحترافي',
  electricity: 'كهرباء',
  electricPortion: 'الجزء الكهربائي',
  electricVehicles: 'السيارات الكهربائية',
  emissions: 'الانبعاثات',
  'Energy Information Administration': 'إدارة معلومات الطاقة',
  estimatedDIYCost: 'متوسط التكلفة التقديرية لأعمال الصيانة المنزلية:',
  'ev.avg.range': 'متوسط نطاق الطاقة الكهربائية',
  'ev.carDetails.batterySizeTooltip':
    'تكفي كيلوواط ساعة واحدة (kWh) لقطع مسافة تتراوح بين 1 و4 أميال، وذلك حسب نوع المركبة. ويمكن لبطارية الكمبيوتر المحمول العادية أن تستوعب أقل من 0.1 كيلوواط ساعة.',
  'ev.cardetails.calc.arborDayFoundation': 'مؤسسة يوم الشجرة',
  'ev.carDetails.calc.charging': 'الشحن',
  'ev.cardetails.calc.chargingRate': 'معدل الشحن',
  'ev.carDetails.calc.chargingRate': 'معدل الشحن',
  'ev.carDetails.calc.DCFC': 'معدل الشحن السريع بالتيار المستمر (DCFC)',
  'ev.cardetails.calc.dcRate': 'معدل الشحن السريع بالتيار المستمر (DCFC)',
  'ev.cardetails.calc.description': 'وصف',
  'ev.carDetails.calc.description': 'وصف',
  'ev.cardetails.calc.EIA': 'إدارة معلومات الطاقة الأمريكية',
  'ev.cardetails.calc.electricEmissions': 'الانبعاثات الكهربائية بالرطل',
  'ev.cardetails.calc.electricEmissionsLbsMwh':
    'الانبعاثات الكهربائية بالرطل/ميغاواط ساعة',
  'ev.cardetails.calc.electricEmissionsLbsMwhMetric':
    'الانبعاثات الكهربائية بالكيلوغرام/ميغاواط ساعة',
  'ev.cardetails.calc.electricEmissionsMetric':
    'الانبعاثات الكهربائية بالكيلوغرام',
  'ev.cardetails.calc.electricityEmissions':
    'انبعاثات الكهرباء بوحدة رطل/ميغاواط ساعة من ثاني أكسيد الكربون',
  'ev.cardetails.calc.electricityEmissionsMetric':
    'انبعاثات الكهرباء بالكيلوغرام من ثاني أكسيد الكربون لكل ميغاواط ساعة',
  'ev.carDetails.calc.electricityEmissionsMetric':
    'انبعاثات الكهرباء بالكيلوغرام من ثاني أكسيد الكربون لكل ميغاواط ساعة',
  'ev.carDetails.calc.emissions': 'الانبعاثات',
  'ev.cardetails.calc.emissionsPerTree': 'الانبعاثات التي تم توفيرها لكل شجرة',
  'ev.cardetails.calc.emissionsReductions': 'تخفيضات الانبعاثات',
  'ev.cardetails.calc.emissionsReudctions': 'تخفيضات الانبعاثات',
  'ev.cardetails.calc.EPA': 'تصنيف كفاءة وكالة حماية البيئة',
  'ev.cardetails.calc.EPAMetric': 'تصنيف كفاءة هيئة التنظيم النووي',
  'ev.carDetails.calc.ev.cardetails.calc.electricityEmissions':
    'انبعاثات الكهرباء بوحدة رطل/ميغاواط ساعة من ثاني أكسيد الكربون',
  'ev.carDetails.calc.fuel': 'وقود',
  'ev.cardetails.calc.FuelConsumptionCa': 'دليل استهلاك الوقود في كندا',
  'ev.cardetails.calc.gallonsSaved': 'جالونات تم توفيرها',
  'ev.cardetails.calc.gallonsSavedFormula':
    'جالونات تستهلكها سيارة تعمل بالبنزين المكافئ - جالونات تستهلكها السيارة الكهربائية',
  'ev.cardetails.calc.gallonsUsed': 'جالونات مستخدمة',
  'ev.cardetails.calc.gallonsUsedFormula':
    'المسافة المقطوعة * (1 - جزء من القيادة الكهربائية) / ميل لكل جالون',
  'ev.cardetails.calc.gasolineEmissions': 'انبعاثات البنزين بالرطل لكل جالون',
  'ev.cardetails.calc.gasolineEmissionskg': 'انبعاثات البنزين بالكيلوغرام',
  'ev.cardetails.calc.gasolineEmissionsLbs': 'انبعاثات البنزين بالرطل',
  'ev.cardetails.calc.gasolineEmissionsMetric':
    'انبعاثات البنزين بالكيلوغرام لكل لتر',
  'ev.cardetails.calc.gasolineEmissionsYr':
    'انبعاثات البنزين بالرطل من ثاني أكسيد الكربون/سنة',
  'ev.cardetails.calc.gasolineEmissionsYrMetric':
    'انبعاثات البنزين بالكيلوغرام من ثاني أكسيد الكربون/سنة',
  'ev.cardetails.calc.kgCo2PerYr': 'كيلوغرامات من ثاني أكسيد الكربون سنوياً',
  'ev.cardetails.calc.kmDrivenPerYr': 'عدد الكيلومترات المقطوعة سنوياً',
  'ev.carDetails.calc.kmDrivenPerYr': 'عدد الكيلومترات المقطوعة سنوياً',
  'ev.carDetails.calc.kwPerKm': 'كيلوواط ساعة لكل 100 كيلومتر',
  'ev.carDetails.calc.kwPerMile': 'كيلوواط ساعة لكل 100 ميل',
  'ev.cardetails.calc.lbsCo2PerYr': 'رطل من ثاني أكسيد الكربون سنوياً',
  'ev.cardetails.calc.litersSaved': 'لترات تم توفيرها',
  'ev.cardetails.calc.litersSavedFormula':
    'لترات تستهلكها سيارة تعمل بالبنزين المكافئ - لترات تستهلكها السيارة الكهربائية',
  'ev.cardetails.calc.litersUsed': 'لترات مستخدمة',
  'ev.cardetails.calc.litersUsedFormula':
    'المسافة المقطوعة بالكيلومترات * (1 - جزء من القيادة الكهربائية) * لتر/100 كم',
  'ev.cardetails.calc.lPer100Km': 'لتر/100 كم',
  'ev.cardetails.calc.lPerKm': 'لترات لكل 100 كيلومتر',
  'ev.cardetails.calc.lpkm': 'لتر/كيلومتر',
  'ev.cardetails.calc.lvl2FullCharge': 'الوقت اللازم للشحن الكامل للمستوى 2',
  'ev.cardetails.calc.lvlTwoChargingRate': 'معدل الشحن من المستوى 2',
  'ev.cardetails.calc.maxACIntake': 'أقصى كمية هواء مكيف الهواء في السيارة',
  'ev.carDetails.calc.milesDriven': 'عدد الأميال المقطوعة سنوياً',
  'ev.cardetails.calc.milesDrivenPerYr': 'عدد الأميال المقطوعة سنوياً',
  'ev.cardetails.calc.milesPerGallon': 'الأميال لكل جالون (MPG)',
  'ev.carDetails.calc.milesPerGallonBasic': 'ميل لكل جالون',
  'ev.cardetails.calc.minOflvl2AC':
    'الحد الأدنى لمعدل الشحن من المستوى 2 والحد الأقصى لاستهلاك التيار المتردد للمركبة',
  'ev.cardetails.calc.mpg': 'ميل/غالون',
  'ev.cardetails.calc.nationalAverageElectricityEmissions':
    'متوسط انبعاثات الكهرباء على المستوى الوطني',
  'ev.cardetails.calc.portionElectric': 'جزء من القيادة الكهربائية',
  'ev.cardetails.calc.portionElectricSource':
    'إدخال المستخدم. بالنسبة للمركبات الهجينة، يتم تقدير نسبة الأميال المقطوعة باستخدام البطارية الكهربائية بدلاً من البنزين.',
  'ev.cardetails.calc.source': 'مصدر',
  'ev.carDetails.calc.source': 'مصدر',
  'ev.cardetails.calc.userInput': 'إدخال المستخدم',
  'ev.cardetails.calc.vehicleBatteryCapacity': 'سعة بطارية السيارة',
  'ev.carDetails.compareText':
    'اخترنا {gasVehicle} بناءً على قربها من {vehicle} بناءً على العلامة التجارية والحجم والسعر.',
  'ev.cardetails.electricRange':
    'لمراعاة تدهور البطارية، فإن المدى المذكور هنا هو تقدير يعتمد على عمر السيارة وأنماط القيادة/الشحن العادية.',
  'ev.carDetails.fastChargingTooltip': 'سرعة الشاحن السريع DC:',
  'ev.carDetails.gasolineSaved': 'تم توفير البنزين',
  'ev.carDetails.kilometerBatterySizeTooltip':
    'تكفي كيلوواط ساعة واحدة (kWh) لقطع مسافة تتراوح بين 1 و4 أميال، وذلك حسب نوع المركبة. ويمكن لبطارية الكمبيوتر المحمول العادية أن تستوعب أقل من 0.1 كيلوواط ساعة.',
  'ev.carDetails.kilometerUsedBatterySizeTooltip':
    'تكفي كيلوواط ساعة واحدة (kWh) لقطع مسافة تتراوح بين كيلومتر واحد وأربعة كيلومترات، وذلك حسب نوع السيارة. ولمراعاة تدهور أداء البطارية في السيارات الكهربائية المستعملة، فإن سعة البطارية المذكورة هنا هي تقديرية بناءً على عمر السيارة وأنماط القيادة والشحن المعتادة.',
  'ev.carDetails.levelTwoChargerSpeedTooltip':
    'عند شحنها باستخدام شاحن من المستوى الثاني، سواءً كان عامًا أو خاصًا، قادر على دعم أقصى معدل شحن داخلي لهذه المركبة. يُرجى العلم بأن برنامج الخصم السكني لشركة "كونسيومرز إنرجي" يُوصي بأفضل ممارسات تصنيف الطاقة بحيث لا تتجاوز 240 فولت/40 أمبير (9.6 كيلوواط) لدوائر الشحن المنزلية.',
  'ev.carDetails.mobile':
    'لمزيد من التفاصيل بما في ذلك الرسوم البيانية وحسابات {amp}، يرجى عرض هذه الصفحة على جهاز كمبيوتر مكتبي.',
  'ev.carDetails.treesPlanted': 'زراعة الأشجار',
  'ev.carDetails.usedBatterySizeTooltip':
    'تكفي كيلوواط ساعة واحدة (kWh) لقطع مسافة تتراوح بين 1 و4 أميال، وذلك حسب نوع السيارة. ولمراعاة تدهور أداء البطارية في السيارات الكهربائية المستعملة، فإن سعة البطارية المذكورة هنا هي تقديرية بناءً على عمر السيارة وأنماط القيادة والشحن المعتادة.',
  'ev.carDetails.view': 'عرض تفاصيل المركبة',
  'ev.cash': 'نقدي',
  'ev.chargingStations.body':
    'أصبح شحن أجهزتك أثناء التنقل أسهل من أي وقت مضى. أدخل موقعك لعرض جميع محطات الشحن القريبة منك.',
  'ev.compareGasVehicle':
    'قارن بين {car} وسيارة تعمل بالبنزين مماثلة، وهي {gasCar}',
  'ev.compareOtherVehicles': 'قارن المركبات الأخرى',
  'ev.costOfPublicCharing': 'التكلفة التقديرية للشحن العام',
  'ev.dealers.body':
    'اكتشف وكلاء بيع السيارات الكهربائية في منطقتك، وانقر على كل وكيل للاطلاع على موقعه ومعلومات الاتصال به.',
  'ev.electricityRateCalc':
    'يتم حساب سعر الكهرباء كسعر مُجمّع بناءً على متوسط استهلاك منزلي يبلغ 700 كيلوواط ساعة. لمعرفة المزيد، يُرجى النقر على {website}',
  'ev.electricPortion': 'جزء من الأميال الكهربائية',
  'ev.electricPortionTooltip':
    'قدّر النسبة المئوية من مسافة قيادتك التي ستكون كهربائية بالكامل. إذا كنت تشحن سيارتك الكهربائية يوميًا وتقود مسافة أقل يوميًا من مدى القيادة الكهربائية الكاملة لسيارتك المفضلة، فستكون النسبة قريبة من 100%. إذا لم تكن متأكدًا من نسبة استخدامك للكهرباء، فاختر 50%.',
  'ev.incentives.title':
    'قد تتوفر إعفاءات ضريبية وحسومات تصل إلى {savings} {lineBreak} لـ {car}',
  'ev.incentives.title.simple': 'الحوافز والخصومات المتاحة',
  'ev.interestRate': 'سعر الفائدة',
  'ev.jumbotron.findADealer': 'ابحث عن موزع',
  'ev.jumbotron.viewAllCars': 'عرض جميع السيارات',
  'ev.kilometersDrivenAnnually': 'عدد الكيلومترات المقطوعة سنوياً',
  'ev.lease': 'إيجار',
  'ev.loan': 'يُقرض',
  'ev.matchScore.adjustment': 'تعديل',
  'ev.matchScore.budget': 'ميزانية',
  'ev.matchScore.charging': 'الشحن',
  'ev.matchScore.maxScore': 'أعلى نتيجة',
  'ev.matchScore.popover':
    'تعتمد نتيجة المطابقة الخاصة بك على تفضيلاتك المختارة.',
  'ev.matchScore.range': 'يتراوح',
  'ev.matchScore.seats': 'مقاعد',
  'ev.matchScore.title': 'نتيجة المباراة',
  'ev.matchScore.totalScore': 'النتيجة الإجمالية',
  'ev.matchScore.yourScore': 'نتيجتك',
  'ev.milesDrivenAnnually': 'عدد الأميال المقطوعة سنوياً',
  'ev.planningRoute.body':
    'أصبح شحن أجهزتك أثناء التنقل أسهل من أي وقت مضى. أدخل وجهتك للاطلاع على جميع محطات الشحن على طول الطريق.',
  'ev.public': 'عام',
  'ev.publicPrivateCharging': 'مزيج من الشحن العام والخاص',
  'ev.purchaseMethod': 'طريقة الشراء',
  'ev.purchaseMethodToolTip':
    'في عقد الإيجار، يجب إعادة السيارة بعد انتهاء مدة الإيجار. أما في حالة التمويل عن طريق قرض، فتُحتفظ بالسيارة بعد سداد القرض بالكامل.',
  'ev.reviews': 'تقييمات من مختلف أنحاء الإنترنت',
  'ev.showSources.assumption': 'افتراض:',
  'ev.showSources.averageInsurancePerYear': 'متوسط التأمين السنوي',
  'ev.showSources.blendedMaintenanceCostPerKilometer':
    'تكلفة الصيانة المختلطة لكل كيلومتر',
  'ev.showSources.blendedMaintenanceCostPerKilometerSource':
    'جزء من تكلفة القيادة الكهربائية المخصصة للصيانة لكل كيلومتر للبنزين والكهرباء',
  'ev.showSources.blendedMaintenanceCostPerMile': 'متوسط تكلفة الصيانة لكل ميل',
  'ev.showSources.blendedMaintenanceCostPerMileSource':
    'جزء من تكلفة القيادة الكهربائية المخصصة للصيانة لكل ميل للبنزين والكهرباء',
  'ev.showSources.capitalizedCost': 'التكلفة الرأسمالية',
  'ev.showSources.capitalizedCostSource':
    'سعر التجزئة المقترح - الدفعة المقدمة - الحوافز الرأسمالية',
  'ev.showSources.capitalizedIncentives': 'الحوافز الرأسمالية',
  'ev.showSources.capitalizedIncentivesSource':
    'الحوافز التي تم رسملتها ضمن عقد الإيجار',
  'ev.showSources.cashFormula':
    'سعر التجزئة المقترح من المصنع * (1 + ضريبة المبيعات) - الحوافز - قيمة إعادة البيع',
  'ev.showSources.dollarPerKilometerDriven':
    'دولار أمريكي لكل 100 كيلومتر يتم قطعها',
  'ev.showSources.dollarPerKilometerDrivenPublicCharging':
    '(التكلفة التقديرية للشحن العام * مزيج الشحن العام/الخاص + سعر الكهرباء * (1 - مزيج الشحن العام/الخاص)) * كيلوواط ساعة لكل 100 كيلومتر',
  'ev.showSources.dollarPerKilometerDrivenSource':
    'تكلفة الكهرباء * استهلاك السيارة من الكهرباء بالكيلوواط/ساعة لكل 100 كيلومتر',
  'ev.showSources.dollarPerMileDriven': 'دولار لكل 100 ميل يتم قطعها',
  'ev.showSources.dollarPerMileDrivenPublicCharging':
    '(التكلفة التقديرية للشحن العام * مزيج الشحن العام/الخاص + سعر الكهرباء * (1 - مزيج الشحن العام/الخاص)) * كيلوواط ساعة لكل 100 ميل',
  'ev.showSources.dollarPerMileDrivenSource':
    'تكلفة الكهرباء * كيلوواط ساعة لكل 100 ميل من استهلاك السيارة',
  'ev.showSources.electricityRate':
    'يتم تحديد سعر الكهرباء بناءً على {website}',
  'ev.showSources.EPAEfficiency': 'تصنيف كفاءة وكالة حماية البيئة',
  'ev.showSources.estimatedCostOfPublicCharging':
    'التكلفة التقديرية للرسوم العامة',
  'ev.showSources.firstLeasePayment': 'الدفعة الأولى من الإيجار',
  'ev.showSources.firstLeasePaymentSource': 'دفعة مقدمة + قسط إيجار شهري',
  'ev.showSources.gasolineCost': 'تكلفة البنزين',
  'ev.showSources.insurancePerYear': 'التأمين السنوي',
  'ev.showSources.insurancePerYearSource':
    'استقراء متوسط تكلفة التأمين في {state}، مدفوعًا بسعر التجزئة المقترح من المصنع للسيارة بالنسبة إلى متوسط سعر التجزئة المقترح من المصنع لـ {msrp}',
  'ev.showSources.insuranceSource': 'متوسط تكلفة التأمين في',
  'ev.showSources.kilometerVehicleKWh':
    'استهلاك الطاقة بالكيلوواط/ساعة لكل 100 كيلومتر',
  'ev.showSources.leaseForumla':
    'الدفعة الأولى للإيجار + (أشهر الملكية - 1) * (الدفعة الشهرية للإيجار) - حوافز الإيجار غير الرأسمالية',
  'ev.showSources.lifetimeKilometers': 'كيلومترات مدى الحياة',
  'ev.showSources.lifetimeMiles': 'أميال مدى الحياة',
  'ev.showSources.loanAmount': 'مبلغ القرض',
  'ev.showSources.loanFormula':
    'سعر التجزئة المقترح * (1 + ضريبة المبيعات) - الدفعة المقدمة',
  'ev.showSources.maintenanceCostReduction':
    'خفض تكاليف صيانة المركبات الكهربائية',
  'ev.showSources.maintenanceCostReductionSource': '{website}',
  'ev.showSources.maintenancePerKilometer': 'تكلفة الصيانة لكل كيلومتر للبنزين',
  'ev.showSources.maintenancePerKilometerElectricity':
    'تكلفة الصيانة لكل كيلومتر للكهرباء',
  'ev.showSources.maintenancePerKilometerElectricitySource':
    'تكلفة الصيانة لكل كيلومتر للسيارات التي تعمل بالبنزين * عامل تخفيض تكلفة صيانة السيارات الكهربائية',
  'ev.showSources.maintenancePerMile': 'تكلفة الصيانة لكل ميل للبنزين',
  'ev.showSources.maintenancePerMileElectricity':
    'تكلفة الصيانة لكل ميل للكهرباء',
  'ev.showSources.maintenancePerMileElectricitySource':
    'تكلفة الصيانة لكل ميل للسيارات التي تعمل بالبنزين * عامل تخفيض تكلفة صيانة السيارات الكهربائية',
  'ev.showSources.maintenancePerMileSource':
    'استقراء متوسط تكلفة صيانة {avgMaintenanceCost}، مدفوعة بسعر التجزئة المقترح من المصنع للمركبة، مقارنةً بمتوسط سعر التجزئة المقترح من المصنع لـ {averageMSRP}',
  'ev.showSources.mixPublicPrivateCharging': 'نظام الشحن المختلط (عام/خاص)',
  'ev.showSources.moneyFactor': 'عامل المال',
  'ev.showSources.moneyFactorSource':
    'يعادل إدخال المستخدم لـ {interestRateAsBasisPoints}',
  'ev.showSources.monthlyDepreciationCost': 'تكلفة الاستهلاك الشهرية',
  'ev.showSources.monthlyDepreciationCostSource':
    '(التكلفة الرأسمالية - القيمة المتبقية) / أشهر الملكية',
  'ev.showSources.monthlyFinancingCost': 'تكلفة التمويل الشهرية',
  'ev.showSources.monthlyFinancingCostSource':
    '(التكلفة الرأسمالية + قيمة إعادة البيع) * عامل التمويل',
  'ev.showSources.monthlyLeasePayment': 'قسط الإيجار الشهري',
  'ev.showSources.monthlyLeasePaymentSource':
    '(تكلفة الاستهلاك الشهري + تكلفة التمويل الشهري) * (1 + ضريبة المبيعات)',
  'ev.showSources.monthlyPayments': 'الدفعات الشهرية',
  'ev.showSources.monthlyPaymentsSource':
    'الوظيفة المالية لمبلغ القرض، وسعر الفائدة، ومدة الملكية بالأشهر',
  'ev.showSources.monthsOfOwnership': 'أشهر من الملكية',
  'ev.showSources.nonCapLeaseIncentives': 'حوافز التأجير غير الرأسمالية',
  'ev.showSources.nonCapLeaseIncentivesSource':
    'الحوافز غير المدرجة في تكلفة الإيجار الرأسمالية',
  'ev.showSources.portionElectricSource':
    'إدخال المستخدم. بالنسبة للمركبات الهجينة، يتم تقدير نسبة الأميال المقطوعة باستخدام البطارية الكهربائية بدلاً من البنزين.',
  'ev.showSources.portionElectricSourceKilometer':
    'إدخال المستخدم. بالنسبة للمركبات الهجينة، يتم تقدير نسبة الكيلومترات المقطوعة باستخدام البطارية الكهربائية بدلاً من البنزين.',
  'ev.showSources.resaleValue': 'قيمة إعادة البيع',
  'ev.showSources.resaleValueSource':
    '{carName}: e^(ln({resaleFactor})/36000*{lifetimeMiles})*MSRP',
  'ev.showSources.totalElectricityCost': 'إجمالي تكلفة الكهرباء',
  'ev.showSources.totalElectricityCostSource':
    'دولار/100 ميل مقطوع * أميال مدى الحياة * {portionEVDriving}/ 100',
  'ev.showSources.totalGasolineCost': 'إجمالي تكلفة البنزين',
  'ev.showSources.totalGasolineCostSource':
    'تكلفة البنزين * عدد الأميال المقطوعة طوال العمر * {portionEVDriving}/ ميل لكل جالون',
  'ev.showSources.totalInsuranceCost': 'إجمالي تكلفة التأمين',
  'ev.showSources.totalInsuranceCostSource':
    'تكلفة التأمين السنوية * سنوات الملكية',
  'ev.showSources.totalKilometerElectricityCostSource':
    'دولار/100 كم مقطوعة * عدد الكيلومترات طوال العمر * {portionEVDriving}/ 100',
  'ev.showSources.totalKilometerGasolineCostSource':
    'تكلفة البنزين * عدد الكيلومترات المقطوعة طوال العمر * {portionEVDriving}/ لتر لكل كيلومتر',
  'ev.showSources.totalKilometerMaintenanceCostSource':
    'تكلفة الصيانة لكل كيلومتر * عدد الكيلومترات المقطوعة طوال عمر السيارة',
  'ev.showSources.totalLoanFormula':
    'الدفعة المقدمة + إجمالي الأقساط الشهرية - الحوافز - قيمة إعادة البيع',
  'ev.showSources.totalMaintenanceCost': 'إجمالي تكلفة الصيانة',
  'ev.showSources.totalMaintenanceCostSource':
    'تكلفة الصيانة لكل ميل * إجمالي الأميال',
  'ev.showSources.totalMonthlyPayments': 'إجمالي المدفوعات الشهرية',
  'ev.showSources.totalMonthlyPaymentsSource': 'القسط الشهري * أشهر الملكية',
  'ev.showSources.totalVehicleCost': 'التكلفة الإجمالية للمركبة',
  'ev.showSources.vehicleKWh': 'استهلاك الطاقة بالكيلوواط/ساعة لكل 100 ميل',
  'ev.showSources.vehiclelPerKm': 'معدل استهلاك الوقود (لتر لكل كيلومتر)',
  'ev.showSources.vehicleMPG': 'معدل استهلاك الوقود (ميل لكل جالون)',
  'ev.showSources.yearsOfOwnership': 'سنوات الملكية',
  'ev.used.electricRange': 'متوسط نطاق الطاقة الكهربائية',
  'ev.used.yearRange': 'النطاق الزمني',
  'ev.usedCarTitle': 'تم استخدام {car}',
  'ev.yearsOwnership': 'سنوات الملكية/الإيجار',
  'evCard.electricRange': 'موقد كهربائي',
  'evCard.matchScore': 'نتيجة المباراة',
  'evCard.seeDetails': 'اطلع على التفاصيل',
  'evCard.seeElectricVehicle': 'انظر المركبات الكهربائية',
  'evCard.totalRange': 'المدى الكلي',
  'eventCard.hostedBy': 'مقدم من',
  'eventCard.inPerson': 'حدث حضوري',
  'eventCard.inPersonAndVirtual': 'فعالية حضورية + فعالية افتراضية',
  'eventCard.learnMore': 'يتعلم أكثر',
  'eventCard.virtualEvent': 'حدث افتراضي',
  'eventCatalog.noEvents':
    'لم يتم العثور على أي فعاليات تطابق معايير البحث الحالية. حاول تغيير معايير البحث.',
  'eventCatalog.noMatch': 'لم نعثر على أي نتائج مطابقة.',
  events: 'الفعاليات',
  'events.allLocations': 'جميع المواقع',
  'events.autoshow': 'معرض السيارات',
  'events.both': 'حضورياً وعبر الإنترنت',
  'events.conference': 'مؤتمر',
  'events.distance': 'مسافة',
  'events.educationEvent': 'فعالية تعليمية',
  'events.inPerson': 'شخصياً',
  'events.inPersonOrVirtual': 'حضورياً أو افتراضياً',
  'events.nationwide': 'على مستوى البلاد',
  'events.nationWide': 'على مستوى البلاد',
  'events.rideAndDrive': 'ركوب وقيادة',
  'events.subHeader':
    'شاهد، المس، واختبر بنفسك سيارة كهربائية في فعالية قادمة.',
  'events.training': 'تمرين',
  'events.virtual': 'افتراضي',
  'events.webinar': 'ندوة عبر الإنترنت',
  eventsDateRange: 'نطاق التاريخ',
  eventsFilters: 'الفلاتر',
  'eventSort.dateLtH': 'التاريخ (الأقرب أولاً)',
  evfilter: 'الفلاتر',
  'evfilter.carTitle': 'تفضيل السيارات الكهربائية',
  'evfilter.fuel': 'وقود',
  'evfilter.fuelTooltip':
    'تستخدم المركبات الكهربائية بالكامل الكهرباء فقط. أما المركبات الهجينة القابلة للشحن فتستخدم الكهرباء والبنزين.',
  'evfilter.type': 'يكتب',
  evFuelType: 'كهربائية بالكامل',
  'evs.budgetAfterIncentives': 'الميزانية بعد الحوافز',
  'evs.buttonMatchScoreAndFilters': 'نتيجة المباراة والفلاتر',
  'evs.chargercard.chargingtime.na': 'غير متوفر',
  'evs.chargerCatalog.noChargers': 'لم يتم العثور على شواحن',
  'evs.chargingAvailability': 'توافر الشحن',
  'evs.disclaimer':
    'قد لا تعكس المركبات المعروضة مدى التوفر الفعلي. لا نؤيد أو نوصي بأي مركبة أو شركة مصنعة محددة للسيارات.',
  'evs.graph.compare':
    'قارن بين السيارات الكهربائية حسب مدى القيادة أو السعر. مرر مؤشر الماوس فوق السيارة الكهربائية لمزيد من التفاصيل.',
  'evs.graph.disclaimer':
    'قد لا تعكس المركبات المعروضة مدى التوفر الفعلي. لا تُؤيد {companyName} أو تُوصي بأي مركبة أو شركة مصنعة محددة للسيارات.',
  'evs.graph.mobile':
    'للاطلاع على الرسم البياني للنطاق مقابل التكلفة، يرجى عرض هذه الصفحة على جهاز كمبيوتر مكتبي.',
  'evs.graph.rangeVsCost': 'المدى مقابل التكلفة',
  'evs.graph.tiles': 'بلاط المركبات',
  'evs.graph.title': 'السيارات الكهربائية',
  'evs.helpMeChoose': 'ساعدني في الاختيار',
  'evs.highPower.legend': 'محطات الطاقة العالية',
  'evs.homeChargingAvailability': 'توافر الشحن المنزلي',
  'evs.homeChargingAvailabilityTooltip':
    'ستكون السيارات الكهربائية أكثر ملاءمة لك إذا تمكنت من شحنها بسرعة في المنزل.',
  'evs.incentivesScoreOptions': 'معايير الأهلية للحصول على الحوافز',
  'evs.levelOne': 'المستوى 1',
  'evs.levelTwo': 'المستوى 2',
  'evs.matchScoreAndFilters': 'تحسين نقاط المطابقة والفلاتر',
  'evs.matchScoreOptions': 'الفلاتر',
  'evs.minSeats': 'الحد الأدنى للمقاعد',
  'evs.noCharging': 'لا حاجة للشحن',
  'evs.other.legend': 'أنواع أخرى من المحطات',
  'evs.public.legend': 'المحطات العامة',
  'evs.roundTripCommute': 'متوسط الأميال اليومية',
  'evs.seats': 'مقاعد',
  'evs.slideMilesDrivenDaily': 'المدى الأدنى',
  'evs.thirdParty':
    '*يحتوي هذا الموقع على روابط لمواقع إلكترونية خارجية تابعة لجهات خارجية. لا تُؤيد شركة SDGE محتوى أو منتجات أي من هذه المواقع، ولا تتحمل أي مسؤولية عنها. يُرجى العلم بأن هذه المركبة قد لا تكون متوفرة في منطقتك. تواصل مع وكيلك المحلي للتأكد من توفرها.',
  'evs.welcomeSub':
    'قم بتخصيص بحثك لاكتشاف السيارات الكهربائية التي تناسب احتياجاتك.',
  'evs.welcomeSubMobile':
    'قم بتخصيص بحثك لاكتشاف السيارات الكهربائية التي تناسب احتياجاتك.',
  'evSort.alphabetical': 'أبجديًا',
  'evSort.chargerPower': 'طاقة الشاحن',
  'evSort.electricRange': 'موقد كهربائي',
  'evSort.matchScore': 'نتيجة المباراة',
  'evSort.priceHtL': 'السعر: من الأعلى إلى الأدنى',
  'evSort.priceLtH': 'السعر: من الأدنى إلى الأعلى',
  'evSort.title': 'فرز حسب',
  FAQ: 'التعليمات',
  feet: 'قدم',
  filing_status_tooltip: 'تُستخدم لتحديد الأهلية للحصول على الحوافز.',
  fuel_tooltip: 'اختر جميع أنواع هياكل المركبات التي تهمك.',
  Finished: 'انتهى',
  'footer.allRights': 'جميع الحقوق محفوظة.',
  'footer.chargingStations': '{chargingStations}',
  'footer.compareVehicles': '{compareVehicles}',
  'footer.copyright':
    '© ١٩٩٨-٢٠٢٦ شركة سان دييغو للغاز والكهرباء. العلامات التجارية المستخدمة هنا هي ملك لأصحابها المعنيين. جميع الحقوق محفوظة.',
  'footer.disclaimer':
    'شركة {COMPANY_NAME}® هي شركة تابعة لشركة Sempra®. SDG&E® و San Diego Gas & Electric علامتان تجاريتان مسجلتان لشركة San Diego Gas & Electric Company.',
  'footer.electricVehicles': '{electricVehicles}',
  'footer.homeChargers': '{homeChargers}',
  'footer.incentives': '{incentives}',
  'footer.jdpDisclaimer':
    'الأرقام المعروضة في هذه الصفحة هي تقديرات مبنية على بيانات مقدمة من جهات خارجية. هذه المعلومات مقدمة لأغراض إعلامية فقط، ولا ينبغي الاعتماد عليها في تقديم المشورة الضريبية أو القانونية أو المالية. لا تقدم كل من J.D. Power® وSDGE أي مشورة ضريبية أو قانونية أو مالية. يجب عليك التحقق بشكل مستقل من التقديرات الواردة هنا قبل القيام بأي معاملة.',
  'footer.poweredBy': 'مدعوم من زابيرايد',
  'footer.ratepayerDisclaimer':
    'يتم تمويل الرسائل الواردة في هذا الموقع من قبل دافعي الضرائب ما لم يُذكر خلاف ذلك.',
  'footer.zappyDisclaimer':
    'الأرقام المعروضة في هذه الصفحة هي تقديرات مبنية على بيانات مقدمة من جهات خارجية. هذه المعلومات مقدمة لأغراض إعلامية فقط، ولا ينبغي الاعتماد عليها في تقديم المشورة الضريبية أو القانونية أو المالية. لا تقدم كل من J.D. Power® وSDGE أي مشورة ضريبية أو قانونية أو مالية. يجب عليك التحقق بشكل مستقل من التقديرات الواردة هنا قبل القيام بأي معاملة.',
  'footer.zappyDisclaimer.one':
    'حلول المركبات الكهربائية © 2026 J.D. Power، مقدمة بإذن.',
  footerPhrase1: 'الأسعار واللوائح',
  footerPhrase10: 'إجمالي أسعار الكهرباء',
  footerPhrase11: 'اختيار العميل',
  footerPhrase2: 'طلب بيانات الطاقة',
  footerPhrase3: 'الشروط والأحكام',
  footerPhrase4:
    'معايير السلوك الخاصة بلجنة تنظيم الطاقة الفيدرالية - الأمر رقم 717',
  footerPhrase5: 'المشاريع الكبرى',
  footerPhrase6: 'خدمة العملاء',
  footerPhrase7: 'منشورات لجنة المرافق العامة في كاليفورنيا',
  footerPhrase8: 'الوظائف',
  footerPhrase9: 'مركز الخصوصية',
  forInstallation: 'للتثبيت',
  forLevelTwoCharger: 'لشاحن المستوى 2',
  forSeparateMeter: 'لعداد منفصل',
  free: 'حر',
  ft: 'قدم',
  galperyear: 'جالون/سنة',
  garage: 'كراج',
  gasoline: 'الغازولين',
  gasolinePrice: 'سعر البنزين',
  gasolinePriceInCentsPerGal_tooltip:
    'أدخل سعر البنزين في منطقتك. يعتمد السعر الافتراضي لدينا على أحدث سعر للبنزين في منطقتك، والذي يتم تحديثه شهرياً.',
  'graph.assumptions': 'الافتراضات',
  'graph.cheaper': 'أرخص',
  'graph.costDifferent': 'لماذا يختلف السعر؟',
  'graph.costOfOwnership.chart.electricity': 'كهرباء',
  'graph.costOfOwnership.chart.gasoline': 'الغازولين',
  'graph.costOfOwnership.chart.insurance': 'تأمين',
  'graph.costOfOwnership.chart.maintenance': 'صيانة',
  'graph.costOfOwnership.chart.vehicle':
    'حوافز صافية على المركبات، إعادة البيع',
  'graph.costOfOwnership.description': 'وصف',
  'graph.costOfOwnership.descriptionRow.electricity': 'كهرباء',
  'graph.costOfOwnership.descriptionRow.gasoline': 'الغازولين',
  'graph.costOfOwnership.descriptionRow.insurance': 'تأمين',
  'graph.costOfOwnership.descriptionRow.maintenance': 'صيانة',
  'graph.costOfOwnership.descriptionRow.vehicle': 'عربة',
  'graph.costOfOwnership.subTitle':
    'الرقم الهيدروجيني {carName} هو {style} {costDeltaText} {costDeltaTextEnding}',
  'graph.costOfOwnership.subTitleThreeCars':
    'يُعدّ طراز {carName} الأرخص تكلفةً للاقتناء لمدة {yearsOfOwnership} سنوات',
  'graph.costOfOwnership.title': 'تكلفة الملكية',
  'graph.costOfOwnership.totalRow': 'المجموع',
  'graph.costToBreakdown': 'تكلفة التعطل',
  'graph.costToBreakdown.note':
    'ملاحظة: يفترض مخطط نقطة التعادل أن المركبات يتم شراؤها نقداً.',
  'graph.costToBreakdown.subTitle':
    'قارن التكلفة الإجمالية طوال عمر {car1} بتكلفة {car2}',
  'graph.costToBreakdown.subTitleThreeCars':
    'قارن التكلفة التراكمية طوال العمر لـ {car1}، و{car2}، و{car3}',
  'graph.costVsRange.afterIncentives': 'ابتداءً من الساعة {price} بعد الحوافز',
  'graph.costVsRange.electricKilometerRange':
    'المدى الكهربائي: {kilometers} كيلومترات',
  'graph.costVsRange.electricRange': 'المدى الكهربائي: {miles} ميل',
  'graph.electricRange.assumption':
    'النطاق مبني على تقديرات وكالة حماية البيئة',
  'graph.electricRange.assumptions': 'الافتراضات',
  'graph.electricRange.description': 'وصف',
  'graph.electricRange.electricity': 'كهرباء',
  'graph.electricRange.gasoline': 'الغازولين',
  'graph.electricRange.gasolineRange': 'مجموعة بنزين',
  'graph.electricRange.subTitle':
    'يبلغ المدى الكهربائي لـ {car} ميلاً {costDeltaText} × {number}',
  'graph.electricRange.subTitleThreeCars': 'يتمتع {car} بأطول مدى كهربائي',
  'graph.electricRange.total': 'المجموع',
  'graph.fuelRange.chart.chargedHome': 'يتم شحنها في المنزل',
  'graph.fuelRange.chart.description': 'وصف',
  'graph.fuelRange.chart.fuelBudget': 'ميزانية الوقود',
  'graph.fuelRange.chart.howFar':
    'ما هي المسافة التي يمكنك قطعها بسيارة {car} بميزانية وقود {budget}؟',
  'graph.fuelRange.chart.kilometers': 'كيلومترات',
  'graph.fuelRange.chart.miles': 'أميال',
  'graph.fuelRange.chart.network': 'على شبكة Plug-In EEverywhere',
  'graph.fuelRange.chart.rangeOn': 'المدى',
  'graph.fuelRange.chart.similarGas': 'مركبة غاز مماثلة',
  'graph.fuelRange.chart.unlimited': 'غير محدود',
  'graph.graphValues': 'قيم الرسم البياني',
  'graph.hide': 'يخفي ',
  'graph.monthlyCostToFill.subTitle':
    '{carName} هو {style} {costDeltaText} لملئه شهريًا',
  'graph.monthlyCostToFill.subTitleThreeCars':
    'يُعدّ تعبئة خزان الوقود ذي الرقم الهيدروجيني 0 أرخص تكلفة شهريًا.',
  'graph.monthlyCostToFill.title': 'تكلفة التعبئة الشهرية',
  'graph.moreExpensive': 'أغلى ثمناً',
  'graph.show': 'يعرض ',
  'graph.showCostBreakdown': 'عرض تفاصيل التكلفة',
  'graph.similarGasVehicle': 'سيارة غاز مماثلة',
  'graph.speedOfCharge.fastChargerTitle':
    'مقدار الشحن لكل 30 دقيقة من الشحن السريع',
  'graph.speedOfCharge.fastChargingSpeed': 'سرعة شحن فائقة',
  'graph.speedOfCharge.kilometersLevelTwoChargerThreeCars':
    'يشحن بأقصى عدد من الكيلومترات في الساعة باستخدام شاحن من المستوى الثاني',
  'graph.speedOfCharge.kilometersThirtyFastChargeThreeCars':
    'يشحن أكبر عدد من الكيلومترات في 30 دقيقة من الشحن السريع',
  'graph.speedOfCharge.kmLevelTwoCharger':
    'كيلومترات في الساعة مع شاحن من المستوى 2',
  'graph.speedOfCharge.kmThirtyFastCharge':
    'كيلومترات لكل 30 دقيقة من الشحن السريع',
  'graph.speedOfCharge.levelTwoChargingSpeed': 'سرعة الشاحن من المستوى 2',
  'graph.speedOfCharge.mphLevelTwoCharger':
    'ميل في الساعة مع شاحن من المستوى 2',
  'graph.speedOfCharge.mphLevelTwoChargerThreeCars':
    'يشحن بأقصى سرعة (كيلومترات في الساعة) باستخدام شاحن من المستوى الثاني',
  'graph.speedOfCharge.mphLevelTwoChargerTitle':
    'مقدار الشحن لكل ساعة من الشحن من المستوى 2',
  'graph.speedOfCharge.subTitle':
    'الشحنات {car} {number} {costDeltaText} {subTitleText}',
  'graph.speedOfCharge.subTitleThreeCars': 'الـ {car} {subTitleText}',
  'graph.speedOfCharge.thirtyFastCharge': 'أميال لكل 30 دقيقة من الشحن السريع',
  'graph.speedOfCharge.thirtyFastChargeThreeCars':
    'يشحن أكبر عدد من الأميال في 30 دقيقة من الشحن السريع',
  'graph.title.costAnalysis': 'تحليل التكاليف',
  'graph.title.electricRange': 'موقد كهربائي',
  'graph.title.miles': 'مايلز',
  'graph.title.speedOfCharge': 'سرعة الشحن',
  'graph.title.totalRange': 'المدى الكلي',
  'graph.toOwnOver': 'امتلاك',
  'graph.year': ' سنة',
  'graph.years': ' سنين',
  'graph.yourEV': 'اختيارك من السيارات الكهربائية',
  hcaCarCondition: 'حالة السيارة',
  hcaCarMake: 'ماركة السيارة',
  hcaCarModel: 'طراز السيارة',
  hcaChargerLocation: 'موقع الشاحن',
  hcaCurrentElectricRate: 'سعر الكهرباء الحالي',
  hcaCurrentMonthlyBill: 'الفاتورة الشهرية الحالية',
  hcaDistanceSliderLabel: 'المسافة: من اللوحة إلى موقع الشحن',
  hcaDistanceSliderLabelToolTip:
    'ضع في اعتبارك أن الدوائر الكهربائية لا تسير عادةً في خط مستقيم بين اللوحة وموقع الشحن بسبب وجود الجدران أو الأرضيات أو المساحات الخارجية بينهما.',
  hcaElectricPanelLocation: 'موقع لوحة الكهرباء',
  hcaIncludedEnergyCosts: 'تكاليف الطاقة مشمولة',
  hcaNewestModels: 'أحدث الموديلات',
  hcaOlderModels: 'الطرازات القديمة',
  hcaPanelLocationRoomType: 'موقع اللوحة نوع الغرفة',
  hcaPortionPublicCharging: 'جزء من الرسوم العامة',
  hcaPortionPublicChargingTooltip:
    'يقوم سائقو السيارات الكهربائية بشحن سياراتهم في المنزل في معظم الأحيان.',
  hcaPublicChargingCost: 'تكلفة الشحن العام',
  hcaWhenWillYouCharge: 'متى ستبدأ في تحصيل الرسوم؟',
  'header.cards.electricians': 'ابحث عن كهربائيين معتمدين',
  'header.cards.home-chargers': 'تسوق أجهزة الشحن المنزلية',
  'header.cards.incentives': 'حوافز البحث',
  'header.cards.rates': 'عرض حاسبة التوفير',
  'header.chargingStations': 'محطات الشحن',
  'header.compareVehicles': 'مقارنة المركبات',
  'header.electricians': 'كهربائيون',
  'header.electricVehicles': 'السيارات الكهربائية',
  'header.electricVehicles.v2': 'استكشف السيارات الكهربائية',
  'header.home': 'بيت',
  'header.homeChargers': 'شواحن منزلية',
  'header.incentives': 'الحوافز',
  'header.newVehicles': 'استكشف خيارات السيارات الكهربائية',
  'header.promise.cta': 'ابدأ بالحوافز',
  'header.promise.subtitle':
    'قم بتقدير ومقارنة تكاليف السيارات الكهربائية، والوفورات، والحوافز، والمزيد.',
  'header.promise.title': 'استفد إلى أقصى حد من سيارتك الكهربائية.',
  'header.rates': 'حاسبة التوفير',
  'header.usedVehicles': 'استكشف خيارات السيارات الكهربائية',
  here: 'هنا',
  high: 'عالي',
  home: 'بيت',
  'home.vehicleCarousel.browseAllEvs': 'تصفح جميع السيارات الكهربائية',
  'home.vehicleCarousel.compareEvs': 'مقارنة السيارات الكهربائية',
  'home.vehicleCarouselSubTitle':
    'قارن اختيارك بسيارة بنزين مماثلة. يمكن للسيارة الكهربائية أن توفر لك\n\nالمال لأنها قد تكون أرخص في التملك والصيانة من سيارة تعمل بالبنزين بنسبة 100%\n\n\nالسيارة التي تعمل بالبنزين.',
  'home.vehicleCarouselTitle':
    'يوجد اليوم عدد أكبر من السيارات الكهربائية أكثر من أي وقت مضى. اكتشف سيارتك.',
  homechargerChargerType: 'نوع الشاحن',
  homechargerEvfilter: 'المرشحات الأساسية',
  homeChargers: 'شواحن منزلية',
  'homeChargers.cable': 'كابل {length} قدم',
  'homechargers.caption':
    'أجهزة الشحن المنزلية المدرجة في هذا الموقع ليست مصنعة أو معتمدة من قبل شركة SDG&E.',
  'homeChargers.cordLength': 'طول السلك',
  'homeChargers.cordLengthHtL': 'طول السلك: من الأعلى إلى الأسفل',
  'homeChargers.cordLengthLtH': 'طول السلك: منخفض إلى مرتفع',
  'homeChargers.disclaimer':
    'هل ترغبون، يا مصنعي الشواحن، في عرض شواحنكم هنا؟ تواصلوا مع {email}.',
  'homeChargers.hardwired': 'سلكي',
  'homeChargers.meterCable': 'كابل {length} متر',
  'homeChargers.portable': 'محمول',
  'homeChargers.price': 'سعر',
  'homeChargers.selectMake': 'اختر ماركة',
  'homeChargers.selectModel': 'اختر طرازًا',
  'homeChargers.socket': 'المقبس',
  'homeChargers.socketTooltip':
    'تختلف أنماط توصيل شواحن السيارات الكهربائية المنزلية. وتتوافق هذه الأنماط مع طريقة تركيب أسنانها في مقبس الحائط. إذا لم تكن متأكدًا من المقبس الأنسب لمنزلك أو مرآبك، فاستشر كهربائيًا معتمدًا.',
  'homeChargers.subText':
    'اختر السيارة التي تهمك لمعرفة وقت الشحن المحدد للبطارية بالكامل.',
  'homeChargers.subtitle':
    'اعثر على خيارات شواحن السيارات الكهربائية من المستوى الثاني التي تناسب احتياجات منزلك وتفضيلاتك فيما يتعلق بالسيارات الكهربائية. اضبط الفلاتر لتخصيص نتائج البحث.',
  'homeChargers.title': 'شواحن منزلية',
  'homeChargers.toFullCharge': 'لشحن كامل',
  'homeChargers.wallMounted': 'مثبت',
  'homeChargers.wifi': 'اتصال واي فاي',
  'homeChargersCard.beforeIncentives': 'قبل الحوافز',
  'homeChargersCard.buy': 'عرض التفاصيل',
  'homeChargersCard.socket': 'مقبس {socket}',
  'homeChargersCard.teslaWarning': 'هذا الشاحن يعمل فقط مع سيارات تسلا',
  'homepage.incentives.exporeIncentives': 'استكشف الحوافز',
  'homepage.incentives.subTitle':
    'اكتشف مقدار التوفير الذي يمكنك تحقيقه عند قيادة سيارة كهربائية، سواء كنت تشتريها أو تستأجرها. يتم تخصيص الحوافز وفقًا لموقعك الجغرافي.',
  'homepage.incentives.title':
    'استكشف الحوافز المحتملة للسيارات الكهربائية والإعفاءات الضريبية',
  'homepage.linkCard.browseElectricVehicles':
    'تصفح المركبات الكهربائية {lineBreak}',
  'homepage.linkCard.discoverIncentives': 'اكتشف حوافز {lineBreak}',
  'homepage.linkCard.findDealers': 'ابحث عن وكلاء {lineBreak}',
  'homepage.linkCard.homeChargers': 'شواحن الصفحة الرئيسية {lineBreak}',
  'homepage.linkCard.locateChargingStations':
    'تحديد مواقع محطات الشحن {lineBreak}',
  'homepage.vehicleCarousel.findEVButton': 'عرض جميع المركبات',
  'homepage.vehicleCarousel.subTitle':
    'اختر سيارة كهربائية وقارن تكلفتها بتكلفة سيارة مماثلة تعمل بالبنزين. يمكن للسيارات الكهربائية أن تساعدك على توفير المال لأنها غالبًا ما تكون أرخص في التملك والصيانة من منافسيها الذين يعملون بالبنزين بنسبة 100%.',
  'homepage.vehicleCarousel.title':
    'تتوفر سيارات كهربائية من طراز {vehicleCount}. اكتشف سيارتك.',
  'homepage.welcome': 'كولتون يستعيد نشاطه',
  'homepage.welcomeSub':
    'دليلك الشامل للسيارات الكهربائية، مقدم من شركة كولتون للكهرباء. قم بتقدير ومقارنة التكاليف والوفورات وحوافز السيارات الكهربائية والمزيد.',
  'homepage.zipcode.disclaimer':
    'خطط أسعار مخصصة في أقل من دقيقة. لا حاجة للتسجيل.',
  'homepage.zipcode.getStarted': 'ابدأ الآن',
  'homepage.zipcode.subtitle':
    'ستحدد هذه الأداة بوضوح خطة تسعير السيارات الكهربائية الأقل تكلفة.',
  'homepage.zipcode.title':
    'هل تعلم أننا نقدم مجموعة متنوعة من خطط تسعير السيارات الكهربائية؟ اعثر على أفضل خطة تسعير تناسبك.',
  homeWiring: 'توصيلات كهربائية منزلية',
  incentives: 'الحوافز',
  'incentives.clunkerNone':
    'تقدم بعض الحوافز تعويضات لك مقابل التخلص من مركبة موجودة، والمعروفة أيضًا باسم المركبة القديمة.',
  'incentives.clunkertoolTip':
    'تُقدم بعض الحوافز تعويضات لك مقابل التخلص من سيارتك القديمة، والمعروفة أيضاً باسم السيارة الخردة. وبالتحديد، فإن',
  'incentives.clunkertoolTipContd':
    'هذه العروض متوفرة في منطقتك. تختلف شروط الأهلية باختلاف الحافز؛ يرجى مراجعة تفاصيل البرنامج.',
  household_income_tooltip:
    'اجمع دخل جميع أفراد الأسرة. تُستخدم لتحديد الأهلية للحصول على الحوافز.',
  household_size_tooltip:
    'تُستخدم لتحديد الأهلية للحصول على الحوافز. قم بتضمين جميع أفراد أسرتك (الزوج/الزوجة، المعالين، إلخ). نادرًا ما تذكر الحوافز أسرًا أكبر من 8 أفراد، لذا اختر 8 إذا كان حجم أسرتك 8 أفراد أو أكثر.',
  'incentives.electricityProvider': 'مزود الكهرباء',
  'incentives.headOfHousehold': 'رب الأسرة',
  'incentives.householdIncome': 'دخل الأسرة',
  'incentives.householdIncomeTooltip':
    'يُستخدم هذا لتحديد أهلية الحصول على الحوافز. يجب تضمين جميع أفراد أسرتك (الزوج/الزوجة، المعالين، إلخ). لا تُشير معظم الحوافز إلى الأسر التي يزيد عدد أفرادها عن 8 أفراد، لذا اختر 8 إذا كان عدد أفراد أسرتك 8 أو أكثر.',
  'incentives.householdSize': 'حجم الأسرة',
  'incentives.householdSizeTooltip':
    'يشمل ذلك جميع أفراد أسرتك (الزوج/الزوجة، المعالين، إلخ). يُستخدم لتحديد أهلية الحصول على الحوافز.',
  'incentives.incentiveEligibility': 'تحديث أهلية الحوافز',
  'incentives.income': 'الدخل والوضع الضريبي',
  'incentives.incomeTooltip':
    'تعتمد أهلية الحصول على الحوافز ومقدارها غالبًا على دخلك. وعادةً ما يكون العملاء ذوو الدخل المنخفض مؤهلين للحصول على خصومات أكبر.',
  'incentives.less': ' أقل',
  'incentives.location': 'موقع',
  'incentives.locationTooltip':
    'تعتمد العديد من الحوافز على مكان إقامتك. أدخل الرمز البريدي الخاص بك للمساعدة في تحديد الحوافز المتاحة في منطقتك.',
  'incentives.married': 'متزوج',
  'incentives.more': '... أكثر',
  'incentives.planClunker': 'هل تخطط لتسليم سيارة قديمة؟',
  'incentives.retiringVehicleTooltip':
    'قد يكون التخلص من سيارة تعمل بالبنزين قديمة شرطاً للحصول على بعض الحوافز.',
  'incentives.selectModel': 'اختر الطراز',
  'incentives.selectTrim': 'اختر نوع التشطيب',
  'incentives.single': 'أعزب',
  'incentives.subTitle':
    'قد تكون مؤهلاً للحصول على حوافز تُخفّض تكلفة شراء أو استئجار سيارة كهربائية. اضبط الفلاتر لتخصيص نتائجك، وانقر على كل مربع لمعرفة المزيد.',
  'incentives.taxFilingStatus': 'حالة تقديم الإقرار الضريبي',
  'incentives.taxFilingStatusTooltip':
    'تُستخدم لتحديد أهلية الحصول على الحوافز.',
  'incentives.title': 'حوافز السيارات الكهربائية',
  'incentives.tradeIn': 'هل ترغب في التخلص من سيارتك؟',
  'incentives.vehicleType': 'نوع المركبة',
  'incentives.vehicleTypeTooltip':
    'تعتمد بعض الحوافز على نوع السيارة التي تشتريها.',
  'incentives.whichVehicle': 'أي سيارة تنوي شراءها؟',
  'incentiveSort.aToZ': 'أبجديًا: من الألف إلى الياء',
  'incentiveSort.largest': 'الأكبر أولاً',
  'incentiveSort.zToA': 'أبجديًا: من Z إلى A',
  'input-zipcode-for-rate-comp-launch':
    'يُستخدم هذا لتحديد أهلية الحصول على الحوافز. يجب تضمين جميع أفراد أسرتك (الزوج/الزوجة، المعالين، إلخ). لا تُشير معظم الحوافز إلى الأسر التي يزيد عدد أفرادها عن 8 أفراد، لذا اختر 8 إذا كان عدد أفراد أسرتك 8 أو أكثر.',
  install: 'ثَبَّتَ',
  kgperyear: 'كجم/سنة',
  kilometersShort: 'كم',
  lbsperyear: 'رطل/سنة',
  linkUnavailable: 'الرابط إلى الشبكة غير متاح',
  literperyear: 'لتر/سنة',
  liveInResidenceState:
    'أسكن في منزل يتلقى خدمة الكهرباء من شركة إكسيل إنرجي في {stateName}',
  loading: 'تحميل',
  low: 'قليل',
  m: 'م',
  make: 'يصنع',
  maps: 'خرائط',
  'matchScore.adjustment': 'تعديل',
  'matchScore.budget': 'ميزانية',
  'matchScore.charging': 'الشحن',
  'matchScore.maxScore': 'أعلى نتيجة',
  'matchScore.popover': 'تعتمد نتيجة المطابقة الخاصة بك على تفضيلاتك المختارة.',
  'matchScore.range': 'يتراوح',
  'matchScore.seats': 'مقاعد',
  'matchScore.title': 'نتيجة المباراة',
  'matchScore.totalScore': 'النتيجة الإجمالية',
  'matchScore.yourScore': 'نتيجتك',
  medium: 'واسطة',
  'miles-driven-annually-range_tooltip':
    'استنادًا إلى تقديرات وزارة النقل لمتوسط الأميال المقطوعة سنويًا في عام 2020، يقطع السائق العادي حوالي 16,000 ميل في السنة.',
  milesDrivenAnnually_tooltip: 'استنادًا إلى وزارة النقل',
  milesWord: 'مايلز',
  modal1: 'ما هو متوسط تكلفة الكهرباء في فاتورتك الشهرية؟',
  modal10: 'نصيحة: يقطع السائق العادي حوالي 12000 ميل في السنة.',
  modal11: 'ما هو الإطار الزمني للشحن الذي يناسبك أكثر؟',
  modal12:
    'نصيحة: يُعدّ الشحن ليلاً (من الساعة 12 صباحاً إلى 6 صباحاً) الأكثر فعالية من حيث التكلفة. يمكنك برمجة سيارتك الكهربائية للشحن خلال الفترة الزمنية التي تناسبك.',
  modal13: 'على مدار الساعة',
  modal14: 'ما هي خطة التسعير الحالية لديكم؟',
  modal15: 'ملاحظة: معظم العملاء مشتركين في باقة TOU-DR1.',
  modal16:
    'ملاحظة: بالنسبة للعملاء المشتركين في خطط التسعير غير المخصصة للسيارات الكهربائية (بما في ذلك DR وTOU-DR1 وDR-SES)، نفترض أنكم تقودون حاليًا سيارة تعمل بالبنزين من نفس النوع والماركة والسعر تقريبًا للسيارة الكهربائية المختارة في الخطوة 2، ونعرض لكم مقدار التوفير الناتج عن التحول إلى هذه السيارة الكهربائية. أما بالنسبة للعملاء المشتركين في خطة التسعير EV-TOU-5، فنفترض أنكم تمتلكون بالفعل السيارة الكهربائية المختارة، ونعرض لكم مقدار التوفير الحالي مقارنةً بخطط التسعير غير المخصصة للسيارات الكهربائية.',
  modal2: 'خطوة',
  modal3: 'ل',
  modal4: 'التالي',
  modal5:
    'ما هي السيارة الكهربائية التي تمتلكها بالفعل أو ترغب في شرائها/استئجارها؟',
  modal6: 'نصيحة: يمكنك تعديل هذه الفلاتر بعد عرض نتائجك.',
  modal7:
    'اختر سيارتك الكهربائية الحالية أو المفضلة للاطلاع على التوفير المحتمل في باقات الأسعار المختلفة. يؤثر اختيار السيارة على التوفير المحتمل في فاتورة الكهرباء نظرًا لاختلاف أداء وكفاءة استهلاك الطاقة الكهربائية بين الطرازات.',
  modal8: 'سابق',
  modal9: 'في المتوسط، كم عدد الأميال التي تقطعها بالسيارة سنوياً؟',
  model: 'نموذج',
  'model.year': 'سنة الصنع',
  month: 'شهر',
  monthWord: 'شهر',
  new: 'جديد',
  newVehicles: 'سيارات جديدة',
  no: 'لا',
  overTenYears: 'أكثر من 10 سنوات',
  pages: 'الصفحات',
  personalizeIncentives: 'تخصيص الحوافز',
  phevFuelType: 'سيارة هجينة قابلة للشحن',
  portionOfPublicCharging: 'جزء من الرسوم العامة',
  portionOfPublicChargingTooltip:
    'إذا لم تتمكن من شحن سيارتك الكهربائية في المنزل، فسيتعين عليك شحنها في محطات الشحن العامة المدفوعة. قدّر النسبة المئوية لوقت شحن السيارة الكهربائية الذي ستقضيه في محطات الشحن العامة المدفوعة بدلاً من المنزل.',
  'pre-owned': 'مستعملة',
  Preferredpartner: 'الشريك المفضل',
  prefferedEvChargingTimeframe: 'الإطار الزمني المفضل لشحن السيارات الكهربائية',
  prefferedEvChargingTimeframe_tooltip:
    'يُعدّ الشحن ليلاً (من الساعة 12 صباحاً إلى 6 صباحاً) الخيار الأمثل من حيث التكلفة. يمكنك برمجة سيارتك الكهربائية للشحن خلال الفترة الزمنية التي تناسبك.',
  prefferedEvMake: 'ماركة السيارات الكهربائية المفضلة',
  prefferedEvMake_tooltip:
    'ملاحظة: نفترض أنك تقود حاليًا سيارة تعمل بالبنزين من نفس النوع والماركة والسعر المماثل للسيارة الكهربائية المختارة.',
  prefferedEvModel: 'طراز السيارة الكهربائية المفضل',
  'pricePanels.cash': 'نقدي',
  'pricePanels.downPayment': 'دفعة مبدئية',
  'pricePanels.downPaymentDescription':
    '10% من سعر التجزئة المقترح بالإضافة إلى الضريبة',
  'pricePanels.firstLeasePayment': 'الدفعة الأولى من عقد الإيجار',
  'pricePanels.incentivesForLease': 'حوافز التأجير',
  'pricePanels.lease': 'إيجار',
  'pricePanels.leasePayment': 'دفعة الإيجار',
  'pricePanels.loan': 'يُقرض',
  'pricePanels.loanPayment': 'سداد القرض',
  'pricePanels.perMonth': ' / شهر',
  'pricePanels.seeAllCosts': 'اطلع على جميع التكاليف',
  'pricePanels.seeAllIncentives': 'اطلع على جميع الحوافز',
  'rateAdvisor.caption':
    'أداة حساب التوفير هذه مُقدمة لأغراض توضيحية فقط. وهي لا تُعدّ وعدًا أو ضمانًا بأن تكاليف الشحن الفعلية ستُساوي التكاليف الموضحة في الأداة. لا تضمن شركة سان دييغو للغاز والكهرباء (SDG&E) دقة أو اكتمال أو فائدة معلومات التكلفة المُقدّرة. تُخلي شركة سان دييغو للغاز والكهرباء (SDG&E) مسؤوليتها صراحةً عن أي أضرار من أي نوع تنشأ عن استخدام أداة حساب التوفير. ستختلف تكاليف الشحن الفعلية بناءً على عدد من العوامل. يُشير مصطلح "SDG&E" إلى شركة سان دييغو للغاز والكهرباء. ©2022 SDG&E. جميع الحقوق محفوظة.',
  'rateAdvisor.pricingPlanComparison': 'مقارنة خطط الأسعار',
  'rateAdvisor.sub':
    'حدد فرص التوفير المتاحة لك مع السيارات الكهربائية. اضبط الفلاتر لعرض مدخراتك.',
  'rateAdvisor.title': 'حاسبة التوفير',
  'rateComparison.youAreAlreadySaving':
    'أنت توفر بالفعل ما يصل إلى {highlightText} إذا كنت تمتلك سيارة كهربائية وتستخدم خطة الأسعار {highlight}.',
  'rateComparison.youAreAlreadySavingVehicle':
    'أنت توفر بالفعل ما يصل إلى {highlightText} سنويًا على {highlight} مع {selectedVehicle}.',
  'rateComparison.youAreSaving':
    'ستوفر ما يصل إلى {highlightText} إذا كنت تمتلك سيارة كهربائية وتستخدم خطة الأسعار {highlight}.',
  'rateComparison.youAreSavingVehicle':
    'يمكنك توفير {highlightText} سنويًا على {highlight} باستخدام {selectedVehicle}.',
  rateDRSESParagraph1:
    'خطة DR-SES مخصصة لعملاء الطاقة الشمسية وغيرها من مصادر الطاقة المتجددة.\n\nيُحدد السعر بناءً على وقت ويوم الأسبوع، بالإضافة إلى كمية الكهرباء التي تستهلكها.\n\nأنت',
  rateDRSESParagraph2:
    'قد يكون هذا الخيار مناسبًا لك إذا كنت تُنتج طاقة متجددة،\n\nوإذا استطعت نقل أنشطتك المتعلقة باستهلاك الطاقة إلى ما قبل الساعة الرابعة مساءً وما بعد الساعة التاسعة مساءً،\n\nوإذا استطعت الاستفادة من انخفاض أسعار الكهرباء خلال\n\nأوقات انخفاض الطلب.',
  rateEVTOU5Paragraph1:
    'خطة EV-TOU-5 مُخصصة للعملاء لشحن سياراتهم الكهربائية في المنزل.\n\nيُحدد السعر بناءً على كمية الكهرباء المُستهلكة وتوقيتها، وذلك ضمن ثلاث فترات تسعير.\n\nمقابل رسوم خدمة أساسية، نقدم\n\nأقل أسعارنا لشحن السيارات الكهربائية ليلاً في المنزل.',
  rateEVTOU5Paragraph2:
    'قد يكون هذا الخيار مناسبًا إذا استطعت تحويل جزء من استهلاكك للكهرباء\n\nبعيدًا عن ساعات الذروة من الرابعة إلى التاسعة مساءً، وإذا استطعت شحن سيارتك الكهربائية بانتظام\n\nخلال فترة انخفاض الطلب في وقت متأخر من الليل.',
  rateTOUDR1Paragraph1:
    'تعتمد أسعار TOU-DR1 على كمية الكهرباء التي تستهلكها، بالإضافة إلى\nوقت ويوم استخدامك لها. مع ثلاث فترات تسعير،\n\nتتاح لك فرصة التوفير بشكل أكبر في الليالي وعطلات نهاية الأسبوع.',
  rateTOUDR1Paragraph2:
    'قد يكون هذا الخيار مناسبًا إذا استطعت تحويل جزء من استهلاكك للكهرباء\n\nبعيدًا عن ساعات الذروة من الساعة 4 إلى 9 مساءً، واستفدت\n\nمن انخفاض أسعار الكهرباء خلال أوقات انخفاض الاستهلاك ليلًا وفي عطلات نهاية الأسبوع.',
  regularResidential: 'سكني عادي',
  'results.updated': 'تم تحديث النتائج اعتبارًا من',
  saved: 'أنقذ',
  'select-charger-level_tooltip':
    'ستكون المركبات الكهربائية أكثر ملاءمة لك إذا كان بإمكانك الشحن بسرعة في المنزل.',
  savingsGraphDisclaimer:
    '* يفترض أنك تقوم بتزويد منزلك بالطاقة باستخدام خطة التسعير هذه وأنك تقود حاليًا سيارة تعمل بالبنزين من نوع وماركة وسعر مشابه للسيارة الكهربائية التي اخترتها.',
  savingsGraphEVLabel: 'سيارة كهربائية',
  savingsGraphGasLabel: 'الغازولين',
  savingsGraphHomeLabel: 'بيت',
  savingsGraphYAxis: 'متوسط التكاليف المقدرة سنوياً',
  source: 'مصدر',
  sources: 'مصادر',
  'tabbed-maps-all-stations-tab': 'محطات الشحن',
  'tabbed-maps-dealer-catalog-tab': 'التجار',
  'tabbed-maps-electricians-tab': 'كهربائيون',
  'tabbed-maps-route-tab': 'حدد مسارًا',
  total: 'المجموع',
  trade_in_tooltip:
    'قد يكون التخلص من مركبة قديمة تعمل بالبنزين مطلوبًا للحصول على بعض الحوافز.',
  trim: 'تقليم',
  type_tooltip:
    'تستخدم المركبات الكهربائية بالكامل الكهرباء فقط. يمكن للمركبات الهجينة القابلة للشحن استخدام الكهرباء والبنزين.',
  Unfinished: 'غير مكتمل',
  updateZipcode: 'تحديث الرمز البريدي',
  usedElectricVehicles: 'سيارات كهربائية مستعملة',
  'vehicle.afterIncentives': 'بعد الحوافز',
  'vehicle.age.four': '4 سنوات فأكثر',
  'vehicle.age.one': 'من 0 إلى 1 سنة',
  'vehicle.age.two': 'من سنتين إلى ثلاث سنوات',
  'vehicle.allElectric': 'كهربائية بالكامل',
  'vehicle.batterySize': 'حجم البطارية',
  'vehicle.bev': 'كهرباء',
  'vehicle.coTwoEmissions': 'خفض انبعاثات ثاني أكسيد الكربون',
  'vehicle.electricRange': 'موقد كهربائي',
  'vehicle.estimatedIncentives': 'الحوافز المقدرة',
  'vehicle.fewer': 'عدد أقل',
  'vehicle.fuelType': 'نوع الوقود',
  'vehicle.gas': 'الغازولين',
  'vehicle.gasoline.metricPrice': 'سعر البنزين (دولار/لتر)',
  'vehicle.gasoline.price': 'سعر البنزين (دولار/غالون)',
  'vehicle.greater': 'أكبر',
  'vehicle.kilometers': 'كيلومترات',
  'vehicle.kilometersCapital': 'كيلومترات',
  'vehicle.kilometersPerThirtyFastCharge':
    'كيلومترات لكل 30 دقيقة من الشحن السريع',
  'vehicle.kilometersShort': 'كم',
  'vehicle.miles': 'أميال',
  'vehicle.milesCapital': 'مايلز',
  'vehicle.milesCaptital': 'مايلز',
  'vehicle.milesPerThirtyFastCharge':
    'عدد الأميال المقطوعة لكل 30 دقيقة من الشحن السريع',
  'vehicle.milesShort': 'مي',
  'vehicle.more': 'أكثر',
  'vehicle.msrp': 'سعر التجزئة المقترح',
  'vehicle.phev': 'الكهرباء والبنزين',
  'vehicle.plugInHybrid': 'سيارة هجينة قابلة للشحن',
  'vehicle.status': 'حالة المركبة',
  'vehicle.timeToChargeLvlTwo': 'حان وقت الشحن - المستوى 2',
  'vehicle.trees': 'الأشجار',
  'vehicle.type': 'يكتب',
  'vehicle.type.coupe': 'كوبيه',
  'vehicle.type.crossover': 'كروس أوفر',
  'vehicle.type.hatchback': 'هاتشباك',
  'vehicle.type.minivan': 'سيارة ميني فان',
  'vehicle.type.sedan': 'سيارة سيدان',
  'vehicle.type.suv': 'سيارة رياضية متعددة الاستخدامات',
  'vehicle.type.truck': 'شاحنة',
  'vehicle.type.wagon': 'عربة',
  'vehicle.view': 'منظر',
  vehicles: 'المركبات',
  'vehicles.new': 'جديد',
  'vehicles.none': 'لم يتم العثور على أي مركبات',
  'incentives.noneFound':
    'لم يتم العثور على حوافز تطابق عوامل التصفية الحالية. حاول توسيع عوامل تصفية المركبة أو الأهلية.',
  'vehicles.used': 'مستخدم',
  vehicleType: 'حدد جميع أنواع هياكل المركبات التي تهمك.',
  viewSavings: 'عرض الخصومات',
  Website: 'موقع إلكتروني',
  yes: 'نعم',
  youAreEligible: 'أنت',
  zipcode: 'الرمز البريدي',
  zipCode: 'الرمز البريدي',
};

export default AR_CUSTOM;
